import { render, staticRenderFns } from "./groupFinal1.vue?vue&type=template&id=87e58eea&scoped=true"
import script from "./groupFinal1.vue?vue&type=script&lang=js"
export * from "./groupFinal1.vue?vue&type=script&lang=js"
import style0 from "./groupFinal1.vue?vue&type=style&index=0&id=87e58eea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e58eea",
  null
  
)

export default component.exports